import CryptoJS from 'crypto-js';

export function aesEncrypt(value, secretInput, ivInput) {
    let secret = CryptoJS.enc.Utf8.parse(secretInput);
    let iv = CryptoJS.enc.Utf8.parse(ivInput);

    let encrypted = CryptoJS.AES.encrypt(value, secret, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    let result = encrypted.toString();

    return result;
};

export function aesDecrypt(value, secretInput, ivInput) {
    let secret = CryptoJS.enc.Utf8.parse(secretInput);
    let iv = CryptoJS.enc.Utf8.parse(ivInput);

    let decrypted = CryptoJS.AES.decrypt(value, secret, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    let result = decrypted.toString(CryptoJS.enc.Utf8);

    return result;
};

export function randomInt(min, max) {
    try {
        let array = new Uint32Array(1);
        crypto.getRandomValues(array);
        let randomCrypto = array[0] % (max - min + 1) + min;
        return randomCrypto;
    } catch {
        console.log("math random");
        let randomMath = Math.floor(Math.random() * (max - min + 1)) + min;
        return randomMath;
    }
}

export function generateLocalAesIv() {
    let timestamp = Math.floor(Date.now() / 1000);
    let random = randomInt(100000, 999999);
    let result = timestamp + '' + random;
    return result;
}

